var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.431,
    height: 35.432,
    viewBox: "0 0 35.431 35.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-miterlimit:10;stroke-width:2px;}.a{stroke:#40b895;}.b{stroke:#4f4f4f;stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M186.627,201.926h-14.18a.558.558,0,0,1-.557-.557v-3.321a.558.558,0,0,1,.557-.557h14.18a.558.558,0,0,1,.557.557v3.321A.558.558,0,0,1,186.627,201.926Z",
    transform: "translate(-163.198 -185.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M210.844,251.717h-7.111a1.193,1.193,0,0,1-1.193-1.193v-8.3h9.5v8.3A1.193,1.193,0,0,1,210.844,251.717Z",
    transform: "translate(-190.808 -225.791)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M89.4,105.341a16.716,16.716,0,1,1,11.558,4.64l-.071-5.392",
    transform: "translate(-84.24 -76.55)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 7.888,
    transform: "translate(12.675 4.106)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 7.888,
    transform: "translate(19.753 4.106)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 4.143,
    transform: "translate(14.504 27.986)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.edb8cd49bcac457977903f77d29fc965.svg";
export { ForwardRef as ReactComponent };